import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DictionaryMessageTypeFuelAppEntity } from '../types/dictionary-message-type-fuel-app-entity';

@Injectable({
  providedIn: 'root'
})
export class DictionaryMessageTypeFuelAppService {
  constructor(private http: HttpClient) { }

  getAll(): Observable<DictionaryMessageTypeFuelAppEntity[]> {
    return this.http.get<DictionaryMessageTypeFuelAppEntity[]>('/api/dictionary/message-types-fuel-app');
  }

  getById(id: number): Observable<DictionaryMessageTypeFuelAppEntity[]> {
    const params = new HttpParams().set('id', id.toString());
    return this.http.get<DictionaryMessageTypeFuelAppEntity[]>('/api/dictionary/message-types-fuel-app', { params });
  }

  add(record: DictionaryMessageTypeFuelAppEntity): Observable<void> {
    return this.http.post<void>('/api/dictionary/message-types-fuel-app', record);
  }

  delete(record: DictionaryMessageTypeFuelAppEntity): Observable<void> {
    return this.http.delete<void>('/api/dictionary/message-types-fuel-app', { body: record });
  }
}

